import React, {useEffect} from 'react'
import PrimaryTitle from '../../components/PrimaryTitle'
import t from '../../service/translate.service'
import PropTypes from 'prop-types'
import ContractSelector from '../../components/contractSelector'
import { Alert } from 'antd'
import LoadingPageOverlay from "../../components/LoadingPageOverlay";

export const LettersRegistration = ({
  handleClick,
  handleCancel,
  contract,
  loading,
  isLettersConsumptionEnabled,
  loaded,
  error,
  setIsLettersConsumptionEnable,
  store
}) => {

  useEffect(() => {
    (async () => {
      store.setLoading(true)
      await setIsLettersConsumptionEnable(contract)
      store.setLoading(false)
    })()
  }, [contract])

  if (loading || (!isLettersConsumptionEnabled && !loaded)) {
    return <LoadingPageOverlay />
  }

  return (
    <div className='wrapper heating-energy-modal' role="dialog" aria-labelledby="letters-title" aria-describedby="letters-description">
      <PrimaryTitle id="letters-title" title={t.LETTERS_TITLE} />
      <div id="letters-description" style={{ marginBottom: '10px' }} className='description'>
        {t.LETTERS_REGISTRATION_TEXT_1}
      </div>
      <div className='description'>{t.LETTERS_REGISTRATION_TEXT_2}</div>
      {error && (
        <Alert
          message={error}
          type='error'
          style={{ marginBottom: '12px', marginTop: '12px' }}
          role="alert"
          aria-live="assertive"
        />
      )}
         <div className='energy-contract-picker'>
            <ContractSelector required={true} page='letters' label padding />
          </div> 
      <div className='btns-holder'>
        {/* <button type='button' className='button primary' onClick={handleClick}>{t.LOYALTY_SUBMIT_CODE}</button> */}
        {/* <button type='button' className='button tertiary' onClick={handleCancel}>{t.HEATING_AND_ENERGY_CANCEL}</button> */}
        <button
          className='button primary'
          onClick={handleClick}
          type='button'
          aria-label={t.LOYALTY_SUBMIT_CODE}
        >
          {t.LOYALTY_SUBMIT_CODE}
        </button>
        <button
          className='button tertiary'
          onClick={handleCancel}
          type='button'
          aria-label={t.HEATING_AND_ENERGY_CANCEL}
        >
          {t.HEATING_AND_ENERGY_CANCEL}
        </button>
      </div>
    </div>
  );
}
LettersRegistration.propTypes = {
    handleClick: PropTypes.func,
    handleCancel: PropTypes.func,
    isLettersConsumptionEnabled: PropTypes.bool,
    loaded: PropTypes.bool,
    setIsLettersConsumptionEnable: PropTypes.func,
    contract: PropTypes.object,
      
}